'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canonizeNpmId = canonizeNpmId;
exports.toCanonicalClassName = toCanonicalClassName;

var _bitJavascriptComponent = require('@bit/bit.javascript.component.npm-id');

var _bitJavascriptComponent2 = _interopRequireDefault(_bitJavascriptComponent);

var _bitJavascriptComponent3 = require('@bit/bit.javascript.component.id');

var _bitJavascriptComponent4 = _interopRequireDefault(_bitJavascriptComponent3);

var _camelcase = require('camelcase');

var _camelcase2 = _interopRequireDefault(_camelcase);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CLASS_CAMELCASE_OPTIONS = {
  pascalCase: true
};

function canonizeNpmId(rawId) {
  var parsed = _bitJavascriptComponent2.default.fromNpmId(rawId);

  if (parsed === undefined) return undefined;
  return parsed.toNpmId({
    includeVersion: false,
    includeFilePath: false
  });
}

function toCanonicalClassName(rawId) {
  var parsed = _bitJavascriptComponent4.default.fromNpmId(rawId) || _bitJavascriptComponent2.default.fromNpmId(rawId);

  var componentName = parsed && parsed.name || 'ThisComponent';
  return (0, _camelcase2.default)(componentName, CLASS_CAMELCASE_OPTIONS);
}